/**
 * The facts the privacy policy and the terms name that only Dallin can
 * give. Each one still in square brackets is a placeholder: it shows on
 * the page as written until it is filled in here, and `PLACEHOLDERS`
 * lists the ones left, so a test can say how many remain.
 */
export const LEGAL = {
    /** The company that runs Job Envoy and is party to the terms. */
    entity: "Anthid LLC, a Delaware limited liability company doing business as Job Envoy",
    /** Where it is. A street address or a PO box goes here once there is one. */
    address: "Seattle, Washington, United States",
    /** Where privacy requests and legal notices go. */
    contactEmail: "support@jobenvoy.ai",
    /** Whose law governs the terms, and whose courts hear a dispute. */
    governingLaw: "the State of Delaware",
    /** The city and state an arbitration hearing, if any, is held in. */
    arbitrationSeat: "Seattle, Washington",
    /** How long operational logs are kept before they age out. */
    logRetention: "14 days",
    /** The recovery window covered by daily snapshots and archived database changes. */
    backupWindow: "7 days",
    /** When recovery files become eligible for deletion from object storage. */
    backupExpiry: "9 days",
    /** The day the privacy policy took effect. */
    effective: "3 November 2026",
    /** The day the unchanged terms took effect. */
    termsEffective: "20 October 2026",
} as const;

/**
 * The versions of the texts this build shows, each the day it took
 * effect, `YYYY-MM-DD`, as the auth service names them. A consent record
 * names these, and the auth service refuses one that is not the version
 * in force (`TERMS_VERSION`, `PRIVACY_VERSION`, `ANALYTICS_CONSENT_VERSION`
 * in apps/auth). Change one only with the text it names.
 */
export const CONSENT_VERSIONS = {
    terms: "2026-10-20",
    privacy: "2026-10-22",
    analytics: "2026-10-20",
} as const;

/** The details still a placeholder: a value in square brackets. */
export function placeholdersOf(details: Readonly<Record<string, string>>): string[] {
    return Object.entries(details)
        .filter(([, value]) => value.startsWith("["))
        .map(([key]) => key);
}

/** Every detail still a placeholder. Empty once all are filled in. */
export const PLACEHOLDERS: readonly string[] = placeholdersOf(LEGAL);
